import { medicalPassport8n } from './forms/medicalPassport8n';

export const formsV2 = {
  medicalPassport8n,
};
